import SegmentCreation from "./SegmentCreation";

export default SegmentCreation;
